export const mutations = {
  init: init => state => {
    return {
      ...state,
      ...init
    };
  },
  editSearchTerm: ({
    term
  }) => state => {
    return {
      ...state,
      next: {
        ...state.next,
        search: term
      },
      prev: {
        ...state.prev,
        search: term
      },
      searchTerm: term
    };
  },
  setFilterStatuses: ({
    statuses
  }) => state => {
    return {
      ...state,
      filterStatuses: statuses
    };
  },
  setFilterDateBefore: ({
    date
  }) => state => {
    return {
      ...state,
      filterDateBefore: date
    };
  },
  setFilterDateAfter: ({
    date
  }) => state => {
    return {
      ...state,
      filterDateAfter: date
    };
  },
  setOrderTerm: ({
    term
  }) => state => {
    return {
      ...state,
      orderTerm: term
    };
  },
  setCurrentPage: ({
    page
  }) => state => {
    return {
      ...state,
      page
    };
  },
  selectRelatedAssignment: id => state => {
    return {
      ...state,
      relatedAssignmentId: id
    };
  },
  updateFragment: (assignmentId, id, body) => state => {
    const assignment = state.assignments.index[assignmentId];
    const fragments = assignment.fragments.map(f => {
      if (f.id === id) {
        return {
          ...f,
          unsafe_body: body
        };
      } else {
        return f;
      }
    });
    const mutAssignment = {
      ...assignment,
      fragments
    };
    return {
      ...state,
      assignments: {
        ...state.assignments,
        index: {
          ...state.assignments.index,
          [assignmentId]: mutAssignment
        }
      }
    };
  },
  updateAssignmentStatus: (id, status) => state => {
    return {
      ...state,
      assignments: {
        ...state.assignments,
        index: {
          ...state.assignments.index,
          [id]: {
            ...state.assignments.index[id],
            status: status
          }
        }
      }
    };
  },
  setAssignmentReadOnly: (id, readonly) => state => {
    return {
      ...state,
      assignments: {
        ...state.assignments,
        index: {
          ...state.assignments.index,
          [id]: {
            ...state.assignments.index[id],
            is_readonly: !!readonly
          }
        }
      }
    };
  },
  assignments: {
    edit: (id, assignment) => state => {
      return {
        ...state,
        assignments: {
          ...state.assignments,
          index: {
            ...state.assignments.index,
            [id]: {
              ...state.assignments.index[id],
              ...assignment
            }
          }
        }
      };
    },
    documents: {
      init: (id, documents) => state => {
        return {
          ...state,
          assignments: {
            ...state.assignments,
            index: {
              ...state.assignments.index,
              [id]: {
                ...state.assignments.index[id],
                documents
              }
            }
          }
        };
      },
      add: (id, document) => state => {
        const isForRelatedAssignment = !!state.relatedAssignmentId;
        let assignment = state.assignments.index[id];
        if (isForRelatedAssignment) {
          const relatedAssignment = state.assignments.index[id].related_assignments.filter(a => a.id === state.relatedAssignmentId)[0];
          relatedAssignment.documents = [...relatedAssignment.documents, document];
          assignment = {
            ...state.assignments.index[id],
            related_assignments: [...state.assignments.index[id].related_assignments.filter(a => a.id !== relatedAssignment.id), relatedAssignment]
          };
        } else {
          assignment = {
            ...state.assignments.index[id],
            documents: [...state.assignments.index[id].documents, document]
          };
        }
        return {
          ...state,
          assignments: {
            ...state.assignments,
            index: {
              ...state.assignments.index,
              [id]: {
                ...assignment
              }
            }
          }
        };
      },
      remove: (id, documentId) => state => {
        const isForRelatedAssignment = !!state.relatedAssignmentId;
        let assignment = state.assignments.index[id];
        if (isForRelatedAssignment) {
          const relatedAssignment = state.assignments.index[id].related_assignments.filter(a => a.id === state.relatedAssignmentId)[0];
          const documents = state.assignments.index[id].documents;
          const filteredDocuments = documents.filter(d => d.id !== documentId);
          relatedAssignment.documents = filteredDocuments;
          assignment = {
            ...state.assignments.index[id],
            related_assignments: [...state.assignments.index[id].related_assignments.filter(a => a.id !== relatedAssignment.id), relatedAssignment]
          };
        } else {
          const documents = state.assignments.index[id].documents;
          const filteredDocuments = documents.filter(d => d.id !== documentId);
          assignment = {
            ...state.assignments.index[id],
            documents: filteredDocuments
          };
        }
        return {
          ...state,
          assignments: {
            ...state.assignments,
            index: {
              ...state.assignments.index,
              [id]: {
                ...assignment
              }
            }
          }
        };
      }
    }
  },
  documents: {
    init: ({
      documents
    }) => state => {
      return {
        ...state,
        documents: {
          ...state.documents,
          ...documents
        }
      };
    },
    add: ({
      projectId,
      document
    }) => state => {
      let existing = {};
      if (Object.keys(state.documents).includes(projectId)) {
        existing = {
          [projectId]: [...state.documents[projectId], document]
        };
      } else {
        existing = {
          [projectId]: [document]
        };
      }
      return {
        ...state,
        documents: {
          ...state.documents,
          ...existing
        }
      };
    },
    remove: ({
      projectId,
      documentId
    }) => state => {
      const existing = state.documents[projectId].filter(d => d.id !== documentId);
      return {
        ...state,
        documents: {
          ...state.documents,
          ...{
            [projectId]: existing
          }
        }
      };
    },
    tree: {
      build: ({
        changes
      }) => state => {
        return {
          ...state,
          document_tree: changes
        };
      }
    }
  }
};